import { ListOfTeamleaderResponse } from './Api/ListOfTeamleaderResponse';

export class TeamLeaderEntity extends ListOfTeamleaderResponse {
	public static tryCast(o: any): TeamLeaderEntity {
		const ret = new TeamLeaderEntity();
		return Object.assign(ret, o);
	}
}
